import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ControlPanelIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ControlPanel",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.71 31.86c-.63 0-1.14-.51-1.14-1.14V13.57a1.14 1.14 0 1 1 2.28 0v17.14c0 .63-.51 1.14-1.14 1.14ZM15.71 7.86c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v5.71c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.71 14.71c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.85c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29S18 11.41 18 10.15s-1.03-2.29-2.29-2.29M26 7.86c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v5.71c0 .63-.51 1.14-1.14 1.14ZM26 31.86c-.63 0-1.14-.51-1.14-1.14v-5.71a1.14 1.14 0 1 1 2.28 0v5.71c0 .63-.51 1.14-1.14 1.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26 19.29c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v17.14c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26 26.14c-2.52 0-4.57-2.05-4.57-4.57S23.48 17 26 17s4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M5.43 31.86c-.63 0-1.14-.51-1.14-1.14v-5.71a1.14 1.14 0 1 1 2.28 0v5.71c0 .63-.51 1.14-1.14 1.14M5.43 19.29c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v17.14c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.43 26.14c-2.52 0-4.57-2.05-4.57-4.57S2.91 17 5.43 17 10 19.05 10 21.57s-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29"
    })]
  }));
};
ControlPanelIcon.displayName = 'ControlPanelIcon';